import axios from "axios";
export default {
    getDocuments: (projectId) => axios.post("/Documents/GetDocuments", { projectId }),
    getObjects: () => axios.post("/Documents/GetObjects"),
    getMethods: () => axios.post("/Documents/GetMethods"),
    runMethods: (documentId, methods, taskResultLimit) => axios.post("/Documents/RunMethods", { documentId, methods, taskResultLimit }),
    saveScript: (data) => axios.post("/Scripts/SaveScript", data),
    getScripts: () => axios.post("/Scripts/GetScripts"),
    runScript: (documentId, scriptId, nodesSource, taskResultLimit) => axios.post("/Scripts/RunScript", { documentId, scriptId, nodesSource, taskResultLimit }),
    deleteScript: (scriptId) => axios.post("/Scripts/DeleteScript", { scriptId }),
    getDocumentTasks: (documentId) => axios.post("/Tasks/GetDocumentTasks", { documentId }),
    getRequestTask: (requestTaskId) => axios.post("/Tasks/GetRequestTask", { requestTaskId }),
    stopRequestTask: (requestTaskId) => axios.post("/Tasks/StopRequestTask", { requestTaskId }),
    restartRequestTask: (requestTaskId) => axios.post("/Tasks/RestartRequestTask", { requestTaskId })
};
